import { Loader, Modal, tokens, Text, HotsauceProvider } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import type { ShowLoaderFunc } from '@hotjar/insights-common/services/Loader/Loader';
import { Loader as LoaderService } from '@hotjar/insights-common/services/Loader/Loader';
import { render, unmountComponentAtNode } from 'react-dom';
import { useTranslation } from '@hotjar/translations';

interface Props {
  message?: string | null;
  distanceFromTop?: number;
}

const S = {
  Modal: styled(Modal)<{ distanceFromTop?: number }>`
    width: 138px;
    min-width: 0;
    min-height: 0;
    padding: ${tokens.spacer.x2} ${tokens.spacer.x1} ${tokens.spacer.x1};
    height: auto;
    margin-top: ${({ distanceFromTop }) => (distanceFromTop ? `${distanceFromTop}px` : '50vh')};
    ${(props) => (props.distanceFromTop ? undefined : 'transform:translateY(-50%)')};
    text-align: center;
  `,
  LoaderContainer: styled.div`
    margin-bottom: ${tokens.spacer.x1};
  `,
};

export function GlobalLoader({ message, distanceFromTop }: Props): JSX.Element {
  const { i18n, ready } = useTranslation();

  return (
    <HotsauceProvider
      i18n={{
        strings: ready ? i18n.getResourceBundle(i18n.language, 'hotsauce') : {},
      }}
    >
      <S.Modal
        isOpen
        contentLabel="loader"
        hideCloseButton
        size="s"
        distanceFromTop={distanceFromTop}
      >
        <S.LoaderContainer>
          <Loader size="xl" />
        </S.LoaderContainer>
        {message && (
          <Text as="p" textType="body2">
            {message}
          </Text>
        )}
      </S.Modal>
    </HotsauceProvider>
  );
}

let root: HTMLElement | null = null;
let container: HTMLElement | null = null;

const showGlobalLoader: ShowLoaderFunc = (message, action, distanceFromTop) => {
  root = root ?? document.getElementById('root');
  container = container ?? document.createElement('div');
  if (action === 'show') {
    root?.appendChild(container);
    render(<GlobalLoader message={message} distanceFromTop={distanceFromTop} />, container);
  } else {
    unmountComponentAtNode(container);
    root?.removeChild(container);
  }
};

export const globalLoader = new LoaderService(
  showGlobalLoader,
  window.setTimeout,
  window.clearTimeout,
);
